import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const Support = () => {
  return (
    <Wrapper>
      <Container>
        <TopContainer>
          <h1>Just like your earnings, we never stop.</h1>
          <p>
            24/7 global support through our community of pretium quam vulputate
            dignissim suspendisse in est ante. Sed enim ut sem viverra aliquet
            eget sit. Magna sit amet purus gravida quis blandit.
          </p>
          <p>
            Auctor neque vitae tempus quam pellentesque. Malesuada fames ac
            turpis egestas maecenas pharetra.
          </p>
          <EmailCapture>
            <input type="email" placeholder="Email" />
            <button>Confirm</button>
          </EmailCapture>
        </TopContainer>
        <ImageContainer>
          <StaticImage
            src="../images/world-wide-web.png"
            alt="A person using a laptop."
            quality="100"
            placeholder="tracedSVG"
          />
        </ImageContainer>
      </Container>
    </Wrapper>
  )
}

export default Support

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`

const Container = styled.div`
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 900px) {
    flex-direction: row-reverse;
  }
`

const TopContainer = styled.div`
  /* width: 95%; */
  /* width: 100%; */
  max-width: 585px;

  p {
    margin-top: 10px;
    line-height: 1.5rem;
  }
`

const EmailCapture = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  input {
    background: none;
    outline: none;
    border: none;
    border-bottom: 2px solid #ccc;
    transition: 0.5s;
    width: 68%;
    font-size: 1rem;

    :focus {
      border-bottom: 2px solid #555;
    }
  }

  button {
    background: none;
    padding: 10px 20px;
    color: #5fcc9c;
    border: 1px solid #5fcc9c;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
  }
`

const ImageContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  width: 80%;

  @media screen and (min-width: 900px) {
    width: initial;
    margin-right: 25px;
  }
`
